import { createLocaleMessages } from '@/utils/i18n';
import { basicColumnTitleZhCN } from './basicColumnTitle/zh-CN';
import { DefineLocalConfig } from './typings';

export default createLocaleMessages<DefineLocalConfig>({
  scanCode: {
    success: {
      title: '扫描成功',
      des: '在微信中轻触允许即可登录',
    },
    reject: {
      title: '你已取消此次登录',
      des: '你可再次扫描登录，或关闭窗口',
    },
  },
  menuCollapse: {
    expand: '收起边栏',
    collapse: '展开边栏',
  },
  help: {
    help: '帮助',
    kefu: '客服',
    feedback: '产品建议及反馈',
  },
  agreePrivacy: '我已阅读并同意',
  checkPrivacy: '请阅读并勾选协议',
  autoRegisteredPhone: '，未注册的手机号将自动注册',
  and: '和',
  generateSuccess: '生成成功！请下载',
  home: {
    button: '开始',
    knows: {
      des: '中文提问，一键搜索全球最新文献、指南、会议，可让AI给出临床建议、学术综述或者科普内容。更可以一键生成专题报告PPT。',
      tooltip: '',
    },
    project: {
      des: '批量上传文献，使用AI表格工具，帮您高效提取文献数据、精准筛选文献，还能指定多篇文献进行实时AI问答。',
      tooltip: '',
    },
    read: {
      des: '上传PDF，30秒获得PPT版解读报告。\n我们针对各类文献设计不同解读方案，还支持实时问答，助您全面理解文献。',
      tooltip: '',
    },
    admin: {
      des: '管理企业账号',
      tooltip: '',
    },
    records: {
      des: '企业数据分析',
      tooltip: '',
    },
  },
  homeHUIZHI: {
    button: '开始',
    knows: {
      des: '快速获取学术科研建议与对应的证据列表，1分钟找出关键文献',
      tooltip: '',
    },
    project: {
      des: '快速查找文献，进行综述解读',
      tooltip: '',
    },
    read: {
      des: '精准解析学术PDF原文，辅助原文速读和精读，提升看文献效率',
      tooltip: '',
    },
    admin: {
      des: '企业管理',
      tooltip: '',
    },
    records: {
      des: '企业数据分析',
      tooltip: '',
    },
  },
  bindPhone: {
    info: '请绑定手机号后使用',
  },
  welcome: {
    enter: '进入产品',
    slogon: 'AI时代的医学搜索和创作平台',
    oneStop: '「知识」「见解」「创作」，AI一站式赋能医学知识学习和应用',
    start: '现在开始吧',
    mediflow: 'KnowS是什么？',
    ai: {
      title: 'AI搜索问答',
      des: '中文提问，一键搜索全球最新文献、指南、会议，可让AI给出临床建议、学术综述或者科普内容。更可以一键生成专题报告PPT。',
    },
    paper: {
      title: '证据分析',
      des: '批量上传文献，使用AI表格工具，帮您高效提取文献数据、精准筛选文献，还能指定多篇文献进行实时AI问答。',
    },
    read: {
      title: '全文精读',
      des: '上传PDF，30秒获得PPT版解读报告。\n我们针对各类文献设计不同解读方案，还支持实时问答，助您全面理解文献。',
    },
    policy: '用户协议',
    privacy: '隐私政策',
    contact: '联系我们',
  },
  basicColumnTitle: basicColumnTitleZhCN,
  menu: {
    home: '首页',
    knows: 'AI搜索',
    manage: '系统性评价',
    read: '全文精读',
    admin: '企业管理',
    records: '数据分析',
    knowledge: '知识库',
    literature: '文献库',
    open: '打开的页面',
    create: '未命名证据集',
    agent: 'AI应用',
    pricing: '价格',
    'domain-opportunity-map': '领域机会定位',
    'case-deconstruction': '研究方法筛选',
    'expert-strategy': '大牛思维学习',
    exploration: '科研方向挖掘',
  },
  menuHUIZHI: {
    home: '首页',
    knows: '科研选题',
    manage: '证据分析',
    read: '文献解读',
    knowledge: '知识库',
    admin: '企业管理',
    records: '数据分析',
    open: '打开的页面',
    create: '未命名证据集',
  },
  chatPdfManage: {
    upload: {
      single: {
        title: '单篇解读',
        desc: '一键生成PPT，对话式解读全文',
        buttonText: '点击上传PDF文件',
      },
      multiple: {
        title: '多篇分析',
        desc: '对多篇全文进行综合分析，并生成PPT',
        buttonText: '即将发布',
      },
      loading: '上传中...',
      parsing: '解析中...',
      limit: '文件大小不能超过50MB',
    },
    list: {
      title: '解读列表',
    },
    detail: {
      file_title: {
        abstract: '原文摘要',
        origin: '文件原文',
      },
      gen_ppt: {
        download: '下载解读PPT',
        generating: '正在生成解读PPT',
        generate: '生成解读PPT',
      },
    },
  },
  manage: {
    unnamed: '未命名证据集',
    title: '我的证据集',
    me: '我',
    newProjectImport: '新建证据集',
    updateSortLabel: '按更新时间，从新到旧',
    createSortLabel: '按创建时间，从新到旧',
    total: '{total}条',
    des: '支持提问、DOI、PMID、Pubmed检索式、上传PDF、Excel文件导入文献',
  },
  created: '创建于',
  updated: '更新于',
  ago: '之前',
  phone: '手机号',
  bind: '绑定',
  weChat: '微信',
  change: '更换',
  logout: '退出登录',
  confirm: '确定',
  cancel: '取消',
  delete: '删除',
  rename: '重命名',
  recover: '恢复',
  undo: '撤销',
  clearFilter: '清除筛选',
  filter: '筛选',
  filter2: '筛选 IF值/发表时间',
  pin: {
    left: '固定在左侧',
    right: '固定在右侧',
  },
  hide: '隐藏',
  ascending: '正序',
  descending: '倒序',
  sortDateAsc: '从旧到新',
  sortDateDesc: '从新到旧',
  sortNumberAsc: '从小到大',
  sortNumberDesc: '从大到小',
  selectAll: '全选',
  introductionEvidence: {
    title: '添加证据',
    limit: {
      row: '单个条件最大查找10000条证据',
      info: '单次导入最大支持10000条证据',
    },
    question: '问题',
    finding: '寻找中',
    importAll: '全部导入',
    uploadText: '点此上传PDF文件',
    identified: '已识别到的证据',
    ask: {
      title: 'AI快搜',
      placeholder: '通过提问添加证据，也可以导入指定证据...',
      enter: 'AI搜索',
      transformButton: '转Pubmed检索式',
    },
    doi: {
      title: 'DOI',
      placeholder: '请输入文献DOI',
      enter: '添加',
    },
    pmid: {
      title: 'PMID',
      placeholder: '请输入文献PMID',
      enter: '添加',
    },
    pubmed: {
      title: 'Pubmed检索式',
      placeholder: '请输入Pubmed检索式',
      enter: '添加',
    },
    upload: {
      title: '上传PDF文件',
    },
    excel: {
      title: '上传Excel文件',
      fileRuleTooltip: 'excel首行必须是列名',
    },
    endnoteXml: {
      title: '上传EndNote文件',
      placeholder: '请上传EndNote XML格式的文件',
      enter: '导入',
    },
  },
  excelUploadModal: {
    title: '请选择Excel文件中的【文献标题列】和【文献摘要列】',
    description: 'AI默认根据这两列进行信息抽取',
    label: {
      title: '文献标题列',
      abstract: '文献摘要列',
    },
    selectColumn: '选择Excel文件中的列',
    warnRequireSelectTitle: '请选择【文献标题列】',
    warnSameSelect: '【文献标题列】和【文献摘要列】不能相同',
  },
  export: '导出',
  share: '共享',
  shared: '共享',
  shareProject: '共享项目',
  shareBanTitle: '开启项目共享时，数据可能会被修改',
  uploadLocalFiles: '上传PDF文件',
  dropUpload: '将文件拖放至任何位置即可上传',
  projectName: '证据集名称',
  addComment: '添加批注',
  changeWeChatTitle: '更换绑定微信',
  weChatLoginTitle: '微信扫码登录',
  changeVerifyCode: '更换短信验证登录',
  changeWeChatScanCode: '更换微信扫码登录',
  or: '或',
  google: {
    login: 'Google登录',
    loginText: '使用Google账号登录',
    loginLoadingText: '正在处理Google登录...',
    loginLoading: '请稍候，正在验证您的身份',
    loginSuccess: 'Google登录成功',
    loginFailed: 'Google登录失败',
  },
  SMS: '验证码登录',
  PASSWORD: '密码登录',
  login: {
    text: '登录',
    email: {
      change: '密码登录',
    },
  },
  verifyMessageTitle: '验证短信',
  getVerifyCode: '获取验证码',
  verifyCode: '验证码',
  sms: {
    login: {
      phone: {
        place: '请输入手机号',
        error: {
          info: '请输入正确的手机号',
        },
      },
      code: {
        place: '请输入验证码',
      },
    },
  },
  autoRegis: '新用户将自动注册',
  seconds: '秒',
  verifyCodeError: '验证码填写错误',
  machineVerify: '机器验证',
  refresh: '刷新',
  refresh1: '换一换',
  clearConversation: '清空会话',
  pdfParsing: '文件解析中，大约需要一分钟，请稍候',
  enterGraphicVerify: '输入上方的图形验证码',
  email: {
    login: {
      account: '账号',
      pwd: '密码',
      passwordPlaceHolder: '请输入密码',
      placeholder: '请输入邮箱',
      placeholder2: '请输入账号',
      tips: '新用户注册',
    },
    register: {
      title: '注册新账号',
      success: {
        msg: '已发送邮箱，请去邮箱链接激活',
      },
      submit: '创建账号',
      setPassword: '设置密码',
      passwordPlaceholder: '密码不能少于6位',
      confirmPassword: '确认密码',
      tips: '已经有账号了',
      goLogin: '去登录',
    },
    forget: {
      text: '忘记密码',
      desc: '输入您加入时使用的电子邮件地址，我们将发送您需要重新设置密码。',
      success: {
        msg: '已发送邮箱，请去邮箱链接重置密码',
      },
      submit: '验证并重置',
    },
    reset: {
      text: '重置密码',
      oldPassword: '旧密码',
      password: '新密码',
      confirmPassword: '确认新密码',
    },
    message: {
      validEmail: '请输入正确的邮箱',
      validAccount:
        '6-20位字符；允许字母/数字/@/./-，最多包含一个下划线；不能以.或-开头',
      confirmPassword: {
        empty: '请确认密码',
        inconformity: '两次密码不一致',
      },
    },
  },
  machine: {
    verify: {
      error: '验证码填写有误',
    },
  },
  question: {
    input: {
      placeholder: '关于这些证据我还想知道',
    },
  },
  insert: {
    blank: {
      column: '插入空白列',
    },
  },
  display: {
    fields: '列编辑',
  },
  wantGetInfo: '想获取的信息',
  import: {
    loading: '导入中',
    text: '导入',
    record: '导入记录',
    done: '完成',
    success: {
      info: '导入成功',
    },
  },
  blank: '空白',
  filters: '筛选',
  fileUpload: {
    sizeLimit: '文件应小于{count}',
  },
  project: {
    deduplication: {
      button: '证据去重',
      title: '证据去重',
      loading: '正在计算重复数据...',
      keep: '保留',
      confirmTitle: '确定去重吗？',
      confirmDesc: '未保留的数据将被删除，删除后不能恢复',
      hasSameCount: '有 {count} 条相似数据，',
      totalSameCount: '共 {count} 条相似数据，',
      judgeBy: '判断依据：',
      keepCount: '保留 {count} 条，',
      removeCount: '删除 {count} 条',
      noData: '暂无重复数据',
    },
    process: {
      loadingText: '剩余 {count} 条',
      calculating: '计算中..',
      stop: '停止',
      halting: '停止中',
      delete: {
        desc: '是否要中断并取消当前证据集所有正在运行的任务？',
        ok: '确认停止',
      },
      failed: '{count} 失败',
      retry: '重试',
      failedText: 'AI运行失败，点击重试',
    },
    popconfirm: {
      delete: {
        title: '确定删除',
        desc: '确定删除所选证据集吗？',
        deleteColumn: '确定删除该列吗？',
      },
    },
    prompFields: {
      pdf: 'PDF全文',
    },
    fields: {
      authors: basicColumnTitleZhCN.authors,
      journal: basicColumnTitleZhCN.journal,
      blankImpactFactorValue: '空',
      impactFactor: 'IF值: {value}',
    },
    blankQuestionTitle: '空',
    blankQuestionContent: '空',
    back: '返回',
    analyzing: '解析中...',
    relatedContent: '相关内容',
    relatedTrials: '相关研究',
    references: '引用文献',
    citations: '被引用文献',
    blankColumn: '空白列',
    newBlankColumn: '新空白列',
    newColumnButton: '创建{name}列',
    newColumnInputPlaceholder: '我还想知道…',
    batchCellModal: {
      button: '批量修改',
      title: '批量修改',
      placeholder: {
        selectColumn: '选择列',
        text: '输入文本',
        number: '输入数字',
        date: '输入日期',
      },
      operate: {
        clear: '清空',
        replace: '替换',
        unshift: '在句首增加',
        push: '在句尾增加',
      },
    },
    knows: {
      actionBar: {
        newButton: '与选中证据对话',
        newLimitTip: '证据数量超{count}篇，系统将自动截取前{count}篇进行回答',
        research_proposal: '以{title}为题，生成开题报告', // 生成开题报告
        protocol: '以{title}为题，生成Protocol', // 生成protocol
        review: '以{title}为题，生成综述', // 生成综述
      },
      drawer: {
        title: '与选中文献对话',
        close: '关闭会话',
        retry: '重试',
        new: '新会话',
        networkError: '网络中断，点击重试',
        answer: '回答：',
        retryByUserCancel: '用户停止响应',
        stop: '停止响应',
        feedbackTitle: '意见反馈',
        feedbackPlaceHolder: '意见描述',
        input: {
          placeholder: '输入你的问题',
          scopeLabel: '问答范围：',
          chooseScopeTitle: '选择问答范围',
          scopeContentLimitTip: '所选范围篇幅过长，将基于有限内容进行回答',
          maxInputLengthLimitTip: '请优化输入问题字数',
          chooseAtLeastOneColumn: '请至少选择一个列名进行回答',
        },
        evidences: {
          title: '选中证据范围 {count}',
          titleTour: '即将根据您选择的 {count} 篇证据进行回答',
          tourConfirm: '知道了',
          abstract: '摘要',
          deleted: '该证据已经删除',
          selectedFirst: '请先选择证据',
        },
        history: {
          title: '历史会话',
          lengthLabel: '证据范围：',
          lengthValue: '{count} 篇',
        },
      },
    },
    table: {
      details: '详情',
      acquiring: '正在获取',
      configHelper: '配置',
      configHelperDone: '完成',
      uploadFile: '上传文件',
      uploadingFile: '上传中',
      sortingInfo: {
        publishDateAsc: '从旧到新',
        publishDateDesc: '从新到旧',
      },
      filterInfo: {
        headerButton: '筛选{count}个条件：',
        dropdownTitle: '筛选条件',
        itemSelected: '已选 {count} 个值',
      },
      filterMenu: {
        include: '包含{total}个',
        exclude: '不包含{total}个',
        reverse: '反选',
        all: '全选',
      },
      selected: '已经选中 {count} 条证据',
      filterInputPlaceholder: '例如：2020',
      filterUniqueValuesTotal: '{total}个',
      deleteConfirm: {
        description: '确定删除所选 {count} 条证据吗？',
        successMessage: '已删除 {count} 条证据',
      },
    },
    citationModal: {
      format: '格式',
      cancel: '取消',
      copy: '复制',
    },
  },
  records: {
    header: {
      total: '共{total}个',
    },
    advancedFilter: {
      dateRange: '时间范围',
      filter: '筛选',
      reset: '重置',
      today: '今天',
      last3Days: '近3天',
      last7Days: '近7天',
      last14Days: '近14天',
      last30Days: '近30天',
      last90Days: '近90天',
    },
  },
  expand: '展开',
  fold: '收起',
  upload: {
    tooLarge: {
      error: '文件过大，上传失败',
      limit: {
        image: '图片最大限制为',
      },
    },
  },
  time: {
    unit: {
      now: '刚刚',
      minutes: '分钟',
      hours: '小时',
      days: '天',
      weeks: '周',
      months: '月',
      years: '年',
      month: '月',
      year: '年',
    },
  },
  ok: '确认',
  common: {
    save: '保存',
    create: '创建',
    cancel: '取消',
    refresh: '刷新',
    edit: '编辑',
    delete: '删除',
    view: '查看',
    download: '下载',
    upload: '上传',
    search: '搜索',
    back: '返回',
    confirm: '确认',
  },
  prompt: {
    text: '问题描述',
    example: '例如:从文本中提取描述患者特征的单词。',
    placeholder: '输入"@"填入底表字段',
    clearConfirm: {
      title: '确定清空列',
      description:
        '由于您的问题描述中对输出格式要求有变化，该列的结构会改变并清空既往值',
    },
    tooltip1: '您可以只输入问题或指令，我们将默认对title和abstract列进行提问；',
    tooltip2: '您也可以通过"@"选择想要提问的列名进行提问。',
    example1: '示例1:患者的年龄',
    example2:
      '示例2:根据{columnTitle} {columnAbstract}判断纳入的患者是否是NSCLC',
  },
  notification: {
    copied: '复制成功',
    noRowsSelected: '请先勾选数据',
    summarizeFirst: '请先进行总结',
    guideDetailsPageIsUnderConstruction: '指南详情页施工中',
    meetingDetailsPageIsUnderConstruction: '会议详情页施工中',
    isReceivingEvidences: '正在响应中',
  },
  tooltip: {
    openInNewWindow: '新标签打开',
    copyDOI: '复制DOI',
    copyPMID: '复制PMID',
    copyUrl: '复制URL',
    download: '下载',
    share: '分享',
    shareCase: '分享案例',
    shareCaseDesc: '任务将以回放的形式分享',
    copyLink: '复制链接',
    generateCitation: '生成Citation',
  },
  copy: '复制',
  months: {
    january: '一月',
    february: '二月',
    march: '三月',
    april: '四月',
    may: '五月',
    june: '六月',
    july: '七月',
    august: '八月',
    september: '九月',
    october: '十月',
    november: '十一月',
    december: '十二月',
  },
  detail: {
    translation: {
      translate: '全文翻译',
      successTip: '翻译成功，请点击下载',
      download: '点击下载',
      loading: '正在翻译中...',
    },
  },
  // knows module
  knows: {
    thematicReport: '专题报告',
    thematicReportDrawer: {
      analyzeQuestion: '分析问题',
      generateOutline: '生成大纲',
      generatePPT: '生成PPT',
      regeneratePPT: '再次生成PPT',
      history: '历史记录',
    },
    queryRecommend: {
      title: '您可能想问',
    },

    filters: {
      publishedSince: '发表时间自',
      studyType: '研究类型',
      Guidelines: '指南/共识',
      Meta: 'Meta分析/系统性综述',
      RCT: 'RCT',
      ClinicalTrial: '临床试验(非RCT)',
      Case: '病例系列/病例报告',
      Literature: '文献综述(非系统性综述)',
      OtherTypes: '社论等特殊类型',
      BasicResearch: '基础研究',
      ObservationalStudy: '观察性研究',
      IF: 'IF值',
      Q: '{count}区',
      subISTEC: '中科院小类分区',
      JCR: 'JCR分区',
      FullText: '是否有全文',
    },
    generatePptByIssueButton: '生成学术演讲PPT',
    downloadPptByIssueButton: '下载学术演讲PPT',
    searchPlaceholder: '输入医学相关的问题',
    searchSubmit: 'AI搜索',
    tabHotQuestions: '大家在问',
    tabHistory: '我提问过',
    clearHistory: '清空',
    backTop: '顶部',
    summary: '总结',
    evidenceSearching: '寻找证据范围: {count}篇',
    relevantEvidence: '已锁定证据范围: {count}篇',
    managePapers: '管理文献',
    aiHint: '内容由 AI 生成，请仔细甄别',
    summaryMode: {
      clinical: '临床建议',
      research: '学术综述',
      popular_science: '科普教育',
    },
    dataScope: {
      MEETING: '国际会议',
      PAPER: 'PubMed文献',
      PAPER_CN: '中文文献',
      TOP_PAPER: '优质文献',
      GUIDE: '国内外指南',
      TRIAL: '临床试验',
      PACKAGE_INSERT: '药品说明书',
    },
    evidenceList: {
      summaryError: 'AI总结失败',
      summaryProcessing: 'AI总结中...',
      sort_option: {
        by_time: '时间从近到远',
        by_if: 'IF值从高到低',
        by_relativity: '相关性从高到低',
      },
    },
  },
  credits: {
    left: '剩余 {count} 积分',
    tips: '一个单元格运行一次预计消耗 1 积分，\n涉及全文的一次消耗10~20积分',
    insufficient2: '您的余额已不足够运行本次操作',
    insufficient: '本次操作预计消耗 {count} 积分，您的余额已不足够运行本次操作',
    largeAmountRemind: '您本次操作预计消耗 {count} 积分',
    largeAmountRemind2:
      '您的操作即将自动运行超过 {count} 个单元格，这可能会产生一定的费用。请您二次确认。',

    usage: {
      tip: '查看积分用量',
      title: '积分用量',
      chat: '文献对话',
      agent: '智能体',
      received: '获得 {count} 积分',
      helpColumn: 'AI提取',
      noMore: '没有更多了',

      knowsAgentSystem: '智能体',
      singleArticleInterpretation: '单篇解读',
      fullTextTranslation: '全文翻译',
      generatePPT: '生成PPT',
      singleQuestionAndAnswer: '单篇问答',
      pcSpecialReport: '专题报告',
      mainQuestionAndAnswer: '快问快答',
      multipleSummaries: '多篇总结',
      multipleConversations: '多篇对话',
      unknown: '其他',
    },
  },
  placeholder: {
    text: '请输入',
    select: '请选择包含目标信息的列',
  },
  priority: {
    HIGH_IF_VALUE: '影响因子优先',
    HIGH_RERANK_SCORE: '系统默认',
    HIGH_PUBLISH_DATE: '最新时间优先',
  },
  setting: {
    title: '设置',
    language: {
      title: '语言',
      desc: '设置您的首选语言，用于界面和AI响应。',
      lang: {
        chinese: '中文',
        english: '英语',
      },
    },
  },
  userInfo: {
    level: {
      label: '当前方案',
      upgrade: '升级',
      subscribe: '订阅',
      renewal: '续订',
      creditPayTip: '仅专业版可充值',

      free: '免费版',
      pro: '专业版',
      bi_pro: '精选版',
      personal: '个人版',
      professional: '专业版',
      ultimate: '专业版',
      customerservice: '企业版',
    },
    payment: {
      amountPayable: '应付金额',
      // 年付价
      yearPayPrice: '年付价',
      productName: '商品名',
      startDate: '生效日期',
      endDate: '时效日期',
      scanToPay: '请扫码完成支付',
      freeGift: '免费赠送',
      payCodeText: '请添加微信客服购买权益',
      payText: '购买咨询',
      startNow: '立即开始',
      subscribeNow: '立即订阅',
      wechatPay: '微信支付',
      alipay: '支付宝',
      wechatText: '请用微信扫码支付',
      alipayText: '请用支付宝扫码支付',
      actualPayment: '应付款',
      // 请选择以下支付方式
      pleaseSelectPaymentMethod: '请选择以下支付方式',
      discount: '已优惠',
      refresh: '刷新页面',
      close: '关闭',
      paySuccess: '恭喜您开通',
      qrCodeExpired: '二维码已失效',
      qrCodeRefresh: '点击刷新',
      workTime: '工作时间',
      contactEmail: '联系邮箱',
      invoiceAfterPay: '付款后联系客服开票',
      contactCustomerService: '联系客服开票',
      // 充值
      recharge: '充值',
      // 积分充值
      creditsRecharge: '积分充值',
      creditTip:
        '温馨提示：积分不可兑换会员，不可转赠，也不可提现；积分充值后有效期为1年，不支持退款或反向兑换为人民币',
    },
    permission: {
      upgrade: '解锁高级权益',
      renewal: '续费 KnowS 专业版',
      subscribe: '会员订阅服务',
      monthPay: '月付',
      yearPay: '年付',
      currentSubscribe: '当前订阅',
      invoice: '支持开具技术服务类发票和会议培训涵',
      subscribePlan: '订阅计划',
      diamondBalance: '积分余额',
      mostDiscount: '最多优惠{discount}%',
      flagship: '旗舰版的所有权益',
      businessManagement: '企业管理:',
      businessManagementContent: '员工账号管理、数据安全&数据隔离',
      moreUsage: '更多的使用额度',
      biggerDiscount: '更大的折扣',
      due: '到期',
      baseScope: '涵盖指南、中英文文献',
      groupAsk: 'AI搜索',
      chat: 'AI搜索提问',
      scope: '涵盖会议',
      evidenceList: '浏览证据列表',
      evidenceExport: '导出证据列表',
      evidenceSummary: 'AI生成证据总结（临床、学术、科普）',
      groupRead: 'AI解读',
      evidenceDetail: '查阅证据详情',
      translate: '中英文翻译',
      aiRead: 'AI一键解读',
      genWord: '生成Word报告',
      genPpt: '生成PPT演示',
      fullText: '全文对话式精读',
      uploadPdf: '支持上传PDF文档进行解读',
      morePaperFilter: '大量文献快速精筛（仅限PC端）',
      multiPaperChat: '多篇文献对话解读（仅限PC端）',
      groupCommon: '通用',
      terminal: '手机、PC双端同步使用',
      share: '证据与总结分享',
      response: '高峰时段优先响应',
      customerService: '一对一专属客服',
      trial: '抢先体验更多AI功能',
    },
  },
  // 知识库管理相关
  kb: {
    title: '知识库',
    tabs: {
      all: '全部',
      my: '我的',
      shared: '共享',
    },
    folder: {
      empty: '暂无文件夹，请创建',
      empty_search: '未找到匹配"{keyword}"的文件夹',
      loading: '加载中...',
      create: '新建文件夹',
      edit: '编辑文件夹',
      name: '文件夹名称',
      rename: '重命名',
      name_required: '请输入文件夹名称',
      name_tooLong: '名称不能超过50个字符',
      name_placeholder: '请输入文件夹名称',
      description: '文件夹描述',
      description_tooLong: '描述不能超过200个字符',
      description_placeholder: '请输入文件夹描述（选填）',
      description_tip:
        '创建后可以在文件夹中添加各种文档资料，便于知识管理与共享。',
      delete: {
        title: '确定删除吗？',
        confirm: '确定要删除文件夹"{name}"吗？此操作不可恢复。',
        success: '文件夹"{name}"删除成功',
      },
      search: '搜索文件夹',
    },
    create: {
      folder: '新建文件夹',
      success: '文件夹创建成功',
      edit: {
        success: '文件夹修改成功',
      },
    },
    document: {
      title: '文档名称',
      type: '类型',
      size: '大小',
      modified: '修改时间',
      updated: '更新于',
      action: '操作',
      view: '查看',
      download: '下载',
      upload: '上传文档',
      create: '新建文档',
      create_types: {
        text: '文本文档',
        spreadsheet: '表格文档',
        presentation: '演示文稿',
      },
      sort: '排序方式',
      empty: '文件夹为空，请上传文档',
      empty_search: '未找到匹配"{keyword}"的文档',
      search: '搜索文档',
      total: '共 {total} 条',
      batch: {
        delete: '批量删除',
      },
      delete: {
        button: '删除',
        confirm: '确定要删除文档"{title}"吗？此操作不可恢复。',
        success: '文档"{title}"删除成功',
      },
      download_failed: '下载失败',
      preview_unsupported: '暂不支持在线预览此类型文档',
    },
    upload: {
      dragText: '点击或拖拽文件到此区域上传',
      hint: '支持单个或批量上传文件',
      submit: '开始上传',
      success: '上传成功',
      failed: '上传失败',
      empty: '请选择要上传的文件',
      noNewFiles: '没有新文件需要上传',
      size_error: '文件大小不能超过100MB',
      type_error: '不支持的文件类型',
      supportFiles: '支持的文件类型:',
      maxSize: '最大文件大小:',
    },
  },
  product: {
    all: '所有产品',
    diagnostic_agent: {
      title: '鉴别诊断',
    },
    quickqa: {
      title: 'AI搜索',
      description:
        '告别“大海捞针”，AI搜遍全球证据，一键分析病例、撰写综述、生成PPT',
      quicksearch: {
        title: '证据快搜',
        description: '精准锁定全球证据，告别繁琐文献检索',
        placeholder: '请用一句话，清晰描述您的问题',
        summaryButton: '总结',
      },
      research: {
        title: '学术综述',
        description: '全面梳理研究脉络，分分钟生成循证领域综述',
        placeholder: '请输入您关注的研究方向或主题',
        summaryButton: '生成学术综述',
      },
      clinical: {
        title: '临床建议',
        description: '秒级分析临床病例，提供个性化循证诊疗方案',
        placeholder: '请简述病例信息 (如主诉、既往史、关键检查结果等)',
        summaryButton: '生成临床建议',
      },
      popular_science: {
        title: '科普教育',
        description: '医学知识速查，秒懂复杂医学概念',
        placeholder: '请输入问题或关键词，获取科普教育总结',
        summaryButton: '生成科普文章',
      },
      report_ppt: {
        title: '学术会议PPT',
        description: '分钟级生成汇报大纲与图文PPT，高效助力学术交流',
        placeholder: '请输入您的汇报主题或核心观点',
        summaryButton: '',
      },
    },
    medagent: {
      title: '科研平台',
      description:
        '会反思、可干预、真研究：超越一问一答，全流程自主决策，交付完整可靠报告',
      tag: '智能体',
      placeholder: '给我布置一个任务',
      replay: '查看回放',
      replay2: '案例回放',
      sameBtn: '做同款',
      replayCases: '经典案例',
      // 去创作
      goCreate: '去创作',
      // 重新回放
      replayAgain: '重新回放',
      // 我要创作
      wantToCreate: '我要创作',
      // 回放已结束
      replayEnd: '回放已结束',
      // 正在回放
      replaying: '正在回放',
      // 您正在查看一个已完成的任务
      replayEndTip: '您正在查看一个已完成的任务',
      // 回放任务
      replayTask: '回放任务',
      // 跳转到结果
      replayToResult: '跳转到结果',
      // 继续执行
      continueTask: '继续执行',
      // 正在执行
      executing: '正在进行',
      // 暂停并接管
      pauseAndTakeOver: '暂停并接管',
      // 正在暂停
      pausing: '正在暂停',
      // 发送并
      sendAndContinue: '发送并继续执行',
      // 正在处理
      processing: '正在处理',
      // 已完成当前任务
      completedCurrentTask: '已完成当前任务',
      // 您介入修改了搜索结果
      userIntervene: '您介入修改了搜索结果',
      // 任务中断
      taskInterrupted: '任务中断',
      // 暂停任务后可进行编辑
      pauseTaskEdit: '暂停任务后可进行编辑',
      // 导出为HTML
      exportAsHtml: '导出为HTML',
      // 导出为PDF
      exportAsPdf: '导出为PDF',
      // 导出为Word
      exportAsWord: '导出为Word',
      // 折叠证据
      foldEvidence: '折叠证据',
      // 展开证据
      unfoldEvidence: '展开证据',

      wajue: {
        title: '选题推荐',
        description: '缺乏灵感？ 为您精准挖掘前沿、高价值的研究方向',
        placeholder: '请输入您长期关注的领域或者一闪而过的灵感',
      },
      chuangxinfangan: {
        title: '可行性评估',
        description: '能否落地？助您挖掘并比较研究路线的投入与风险',
        placeholder: '请输入明确的科学假设，或待解决的科学问题',
      },
      daniu: {
        title: '大牛思路洞察（即将开放）',
        description: '解析大牛科研思维',
        placeholder: '请输入您长期关注的领域或者一闪而过的灵感',
      },
      gaofen: {
        title: '高分课题生成（即将开放）',
        description: '智能生成高潜力课题',
        placeholder: '请输入明确的科学假设，或待解决的科学问题',
      },
    },
    pdf: {
      title: '更多医学工具',
      description: '告别逐字阅读，AI帮你划重点，一键生成解读PPT',
      chat: {
        title: '单篇文献问答',
        description: '对话式解读全文',
      },
      translate: {
        title: '英文文献翻译',
        description: '一键专业翻译学术文献',
      },
      summary: {
        title: '文献解读PPT',
        description: '一键生成学术交流PPT',
      },
    },
    pingjia: {
      title: '系统性评价',
      description: '告别“人肉”筛选，AI逐篇评估，1小时完成三个月工作量',
    },
    medppt: {
      title: '医学PPT',
      description: '告别繁琐制作，AI帮你一键生成学术交流PPT',
    },
    expertWorkbench: {
      title: '专家工作台',
      consultation: '专家咨询',
    },
    caseManage: {
      title: '病例分析',
      description: '告别繁琐制作，AI帮你一键生成学术交流PPT',
      expertConsultation: {
        title: '发起专家咨询',
        initiate: '发起专家咨询',
        selectExpert: '选择专家',
        consultQuestion: '咨询问题',
        selectData: '附带材料',
        originalCase: '原始病历',
        caseSummary: '病案整理',
        diagnosticSuggestion: '诊断建议',
        treatmentRecommendation: '治疗推荐',
        submit: '提交咨询',
        cancel: '取消',
        success: '咨询提交成功',
        error: {
          noExpert: '请选择专家',
          noQuestion: '请输入咨询问题',
          noData: '请至少选择一项数据',
        },
      },
    },
  },
  documentTranslate: {
    title: 'AI智能文档翻译',
    subtitle: '支持PPT、Word、Excel格式',
    description:
      '寻找一种简单的方式来翻译Office文档？我们的AI智能翻译工具可以快速将您的Office文档翻译为您想要的语言，保持原有格式和布局。',
    upload: {
      title: '上传文档',
      dragText: '拖拽文件到此处，或',
      clickText: '点击上传',
      supportedFormats: '支持格式：PPT、Word、Excel',
      maxSize: '文件大小不超过300MB',
      uploading: '正在上传...',
      uploadSuccess: '上传成功',
      uploadError: '上传失败',
    },
    detail: {
      // 解析文档
      parsing: '解析文档',
      parsingDesc: '分析文档结构和布局信息',
      // 翻译文本内容
      translating: '翻译文本内容',
      translatingDesc: '智能翻译文档中的文字内容',
      // 智能调整版式
      adjusting: '智能调整版式',
      adjustingDesc: '优化翻译后的文档布局',
      // 生成最终文件
      generating: '生成最终文件',
      generatingDesc: '正在生成可下载的翻译文档',

      // 翻译失败
      translateFailed: '翻译失败',
      translateFailedDesc: '翻译过程中出现了问题',
      // 翻译完成
      translateCompleted: '翻译完成',
      translateCompletedDesc: '您的文档已成功翻译完成',

      // 文档翻译进行中
      translateProcessing: '文档翻译进行中',
      translateProcessingDesc: '请稍候，我们正在为您处理文档...',
      // 失败原因
      failReasons: '失败原因',
      // 总体进度
      totalProgress: '总体进度',
      // 下载翻译后的文档
    },
    features: {
      title: '为什么选择我们？',
      subtitle: '我们提供专业的文档翻译服务，让您的演示文稿轻松跨越语言障碍',
      feature1: {
        title: 'AI翻译',
        description: '先进的AI技术确保翻译准确性和流畅性',
      },
      feature2: {
        title: '安全可靠',
        description: '文件加密传输，翻译完成后自动删除，保护您的隐私',
      },
      feature3: {
        title: '一键下载',
        description: '翻译完成后可直接下载，支持原格式导出',
      },
      feature4: {
        title: '在线预览',
        description: '翻阅翻译结果在线预览，确认无误后再下载',
      },
      feature5: {
        title: '多语言支持',
        description: '支持多种语言翻译您的文档',
      },
      feature6: {
        title: '快速处理',
        description: '平均处理时间2-5分钟，大文件也能快速完成',
      },
    },
    tips: {
      title: '提示',
      content: '文档中的图片、图表内的文字暂不支持翻译，请下载后手动处理。',
      // 安全加密傳輸
      security: '安全加密传输',
      // 支持批量處理
      batch: '支持批量处理',
      // 支持多種格式
      format: '支持多种格式',
      // 支持多種語言翻譯
      language: '支持多种语言翻译',
    },
    language: {
      setting: '翻译设置',
      selectLanguage: '选择翻译语言',
      autoDetect: '自动检测',
      source: '源语言',
      target: '目标语言',
      english: '英文',
      chinese: '中文(简体)',
      traditionalChinese: '繁体中文',
      simplifiedChinese: '简体中文',
    },
    translate: {
      start: '开始翻译',
      processing: '正在翻译...',
      success: '翻译完成！',
      error: '翻译失败',
    },
    progress: {
      parsing: '正在解析文档结构...',
      translating: '正在翻译文本内容...',
      adjusting: '正在智能调整版式...',
      generating: '生成最终文件中...',
      slide: '幻灯片',
      page: '第',
    },

    download: {
      title: '下载翻译后的文档',
      other: '翻译其他文档',
    },
    status: {
      ready: '准备就绪',
      processing: '处理中',
      completed: '已完成',
      failed: '失败',
    },
  },
  newHome: {
    slogan: '让决策不滞后，让学术更前沿',
    button: '立即使用',
    whyknows: {
      title: '为什么选择 KnowS?',
    },
    betterGpt: {
      title: 'KnowS 比GPT们更适合医学领域',
      better1: '1. 更懂医学：千万医学数据训练，精准掌握医学术语与知识体系。',
      better2: '2. 更懂循证：实时更新与搜索权威学术库，精准提供前沿医学证据。',
      better3: '3. 更懂医生：一键生成场景化解答，无缝融入日常临床和科研工作。',
      bad1: '1. 医学专业性差：复杂的医学术语理解错误，容易导致幻觉。',
      bad2: '2. 证据不全面：媒体数据来源，权威性和全面性均不足。',
      bad3: '3. 医学适用性差：回答缺乏深度医学分析，调教费时费力。',
    },
    agent: {
      title: 'KnowS自主研发模型: 确保医学信息精确性',
      section1: {
        title: '医学知识图谱与大模型双轮驱动',
        des: '专业多病种医学知识图谱深度融合大语言模型，结合思维链（CoT）技术，实现医学内容精准解读与可靠推理',
      },
      section2: {
        title: '专业医学翻译模型',
        des: '零假设多年积累和医学专业人员标注，结合上下文语义理解技术，解决医学领域复杂术语翻译难题，较传统翻译模型成本更低，精度更高',
      },
      section3: {
        title: '独家 V&V（Verification&Validation）验证模型',
        des: '模拟医学领域专家审查流程，从真实性、一致性、相关性等方面，对生成的医学内容进行事实验证，有效避免大模型幻觉，确保每一条医学内容都可信',
      },
    },
    footer: {
      contact: '联系我们',
      wechat: '微信公众号',
      wechat_enterprise: '客服企业微信',
      xhs: '小红书',
      privacy: '隐私政策和使用条款链接：',
      work_time: '工作时间',
      email: '邮箱联系',
    },
  },
});
